export function updateForeignLegalRepresentativeData(foreignLegalRepresentativeDataRepository, foreignLegalRepresentativeData, foreignLegalRepresentativeDataId) {
  return foreignLegalRepresentativeDataRepository.update(foreignLegalRepresentativeData, foreignLegalRepresentativeDataId);
}